 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"runtime": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/h5-" + ({"keyPointsByTeacher":"keyPointsByTeacher","MyBalance~MyBonus":"MyBalance~MyBonus","MyBalance":"MyBalance","MyBonus":"MyBonus","MyBeans":"MyBeans","feed-back-result":"feed-back-result","lesson-evaluation":"lesson-evaluation","mp-login":"mp-login","parentspraise":"parentspraise","playback":"playback","protocol":"protocol","public-liveroom":"public-liveroom","questionnaire":"questionnaire","share-mvp":"share-mvp","class-detail~personal-center~pintuan":"class-detail~personal-center~pintuan","class-detail":"class-detail","personal-center":"personal-center","pintuan":"pintuan","order":"order","pintuanShare":"pintuanShare","experience-lesson":"experience-lesson","feedBack":"feedBack","detail":"detail","distdetail":"distdetail","feed-back-details":"feed-back-details","hof":"hof","teacher":"teacher","trace":"trace","imageUpload":"imageUpload","liveroom":"liveroom","upload":"upload","nimsdk":"nimsdk"}[chunkId]||chunkId) + "." + {"0":"6f1820920b","1":"0e4215bbd6","2":"04022a795b","3":"35b9b8d23d","4":"c13652d941","5":"53f1cd1005","6":"72e71bd25f","7":"9c0829a82a","8":"07e7d5365a","9":"7b646ad251","10":"04f2fd0f7e","11":"c67f1c8651","12":"80cffd489e","13":"6d2b1ce316","14":"45ab355280","15":"dc3e20dae1","16":"d8ad760233","17":"6fec707e83","18":"d4a92f5393","19":"432097eb3c","20":"e0ce5f427d","21":"801768b85a","22":"b7320f0fed","23":"d83a815a09","24":"a50530ec4b","25":"6209805d44","26":"f52082a8f9","27":"d6daeda6af","28":"19f5578ff1","29":"440a548718","30":"333a7b4f32","31":"5669ad0ff1","32":"6cab175f7c","33":"311c288779","34":"cc8a2731f1","35":"e5aebba28f","36":"299c88ca81","37":"b9db5c0ecf","38":"1c0b787d77","39":"d9b9935e69","40":"a70aad282e","41":"df18af2366","42":"769065b2d5","43":"8084dfd8d0","44":"23a144e5d8","45":"c1297fa508","46":"de82053ebc","47":"d281256b83","48":"7e7b404892","49":"c3e96c4603","50":"b5b78846d0","51":"89685f638a","52":"e9cf5bc59b","53":"e3f68e52dc","54":"dc3a3433e9","55":"9c58ec1af3","56":"56ad0da9c1","57":"8d672d3e44","58":"ced7144a16","59":"199a23b5a8","60":"06332a5343","61":"f8dae1ee9b","62":"522563eb82","63":"815c5593cb","64":"247220f660","65":"7da38321e8","66":"3d686b7868","67":"e8b79a21f9","68":"8d1cb02a7b","69":"ea5d0b71c3","70":"98b0f577ab","71":"217850bf96","72":"e465951bc3","73":"2431f38451","74":"6aa13706c0","75":"45be028fd9","76":"a5af65f3c1","77":"80430b7b18","78":"8c3ab6082b","79":"49780667df","80":"644386f5c0","81":"3ca3714348","82":"8a7f5c740c","83":"834780fd51","84":"fe84b2b50e","85":"1d839a8b34","86":"9059259b72","87":"d49f167b1a","88":"3e8046f0fa","89":"d2e01c830e","90":"bd9c3bd10b","91":"e47192955d","92":"c541d349d2","93":"34b506bf39","94":"6ee6e96a11","95":"1b4238f429","96":"0e9078cc9a","97":"0a988f5937","98":"68cc4a451a","99":"03a44912e3","100":"80e5f8fdc0","keyPointsByTeacher":"38316afed7","MyBalance~MyBonus":"d1663fa205","MyBalance":"96c9dc7ca5","MyBonus":"b989e989b9","MyBeans":"bf9bb58595","feed-back-result":"aa75b7777a","lesson-evaluation":"c7701ff1d5","mp-login":"e18653e3af","parentspraise":"fb244dc0d6","playback":"affa2729ed","protocol":"c27f1211b5","public-liveroom":"c7d60e4eff","questionnaire":"8a0407f55e","share-mvp":"1f2b8c388b","class-detail~personal-center~pintuan":"a4f398d614","class-detail":"0063c92b81","personal-center":"fa0acc3431","pintuan":"38f6012077","order":"adb11ac077","pintuanShare":"caff9b8f50","experience-lesson":"59b1c4d859","feedBack":"54e0fc1263","detail":"1582d64245","distdetail":"defa0ea319","feed-back-details":"ade4fdd536","hof":"3445e98cd6","teacher":"ff72787f9c","trace":"50122d7d98","imageUpload":"c48b753342","liveroom":"fe41ad8dee","upload":"7cc196c58a","nimsdk":"efad7243b9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"6":1,"7":1,"28":1,"34":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + chunkId + ".app." + {"0":"31d6cfe0d1","1":"31d6cfe0d1","2":"31d6cfe0d1","3":"31d6cfe0d1","4":"31d6cfe0d1","5":"31d6cfe0d1","6":"4ef8fa4a46","7":"8a869e0cf2","8":"31d6cfe0d1","9":"31d6cfe0d1","10":"31d6cfe0d1","11":"31d6cfe0d1","12":"31d6cfe0d1","13":"31d6cfe0d1","14":"31d6cfe0d1","15":"31d6cfe0d1","16":"31d6cfe0d1","17":"31d6cfe0d1","18":"31d6cfe0d1","19":"31d6cfe0d1","20":"31d6cfe0d1","21":"31d6cfe0d1","22":"31d6cfe0d1","23":"31d6cfe0d1","24":"31d6cfe0d1","25":"31d6cfe0d1","26":"31d6cfe0d1","27":"31d6cfe0d1","28":"b0b0744f91","29":"31d6cfe0d1","30":"31d6cfe0d1","31":"31d6cfe0d1","32":"31d6cfe0d1","33":"31d6cfe0d1","34":"b799b474ae","35":"31d6cfe0d1","36":"31d6cfe0d1","37":"31d6cfe0d1","38":"31d6cfe0d1","39":"31d6cfe0d1","40":"31d6cfe0d1","41":"31d6cfe0d1","42":"31d6cfe0d1","43":"31d6cfe0d1","44":"31d6cfe0d1","45":"31d6cfe0d1","46":"31d6cfe0d1","47":"31d6cfe0d1","48":"31d6cfe0d1","49":"31d6cfe0d1","50":"31d6cfe0d1","51":"31d6cfe0d1","52":"31d6cfe0d1","53":"31d6cfe0d1","54":"31d6cfe0d1","55":"31d6cfe0d1","56":"31d6cfe0d1","57":"31d6cfe0d1","58":"31d6cfe0d1","59":"31d6cfe0d1","60":"31d6cfe0d1","61":"31d6cfe0d1","62":"31d6cfe0d1","63":"31d6cfe0d1","64":"31d6cfe0d1","65":"31d6cfe0d1","66":"31d6cfe0d1","67":"31d6cfe0d1","68":"31d6cfe0d1","69":"31d6cfe0d1","70":"31d6cfe0d1","71":"31d6cfe0d1","72":"31d6cfe0d1","73":"31d6cfe0d1","74":"31d6cfe0d1","75":"31d6cfe0d1","76":"31d6cfe0d1","77":"31d6cfe0d1","78":"31d6cfe0d1","79":"31d6cfe0d1","80":"31d6cfe0d1","81":"31d6cfe0d1","82":"31d6cfe0d1","83":"31d6cfe0d1","84":"31d6cfe0d1","85":"31d6cfe0d1","86":"31d6cfe0d1","87":"31d6cfe0d1","88":"31d6cfe0d1","89":"31d6cfe0d1","90":"31d6cfe0d1","91":"31d6cfe0d1","92":"31d6cfe0d1","93":"31d6cfe0d1","94":"31d6cfe0d1","95":"31d6cfe0d1","96":"31d6cfe0d1","97":"31d6cfe0d1","98":"31d6cfe0d1","99":"31d6cfe0d1","100":"31d6cfe0d1","keyPointsByTeacher":"31d6cfe0d1","MyBalance~MyBonus":"31d6cfe0d1","MyBalance":"31d6cfe0d1","MyBonus":"31d6cfe0d1","MyBeans":"31d6cfe0d1","feed-back-result":"31d6cfe0d1","lesson-evaluation":"31d6cfe0d1","mp-login":"31d6cfe0d1","parentspraise":"31d6cfe0d1","playback":"31d6cfe0d1","protocol":"31d6cfe0d1","public-liveroom":"31d6cfe0d1","questionnaire":"31d6cfe0d1","share-mvp":"31d6cfe0d1","class-detail~personal-center~pintuan":"31d6cfe0d1","class-detail":"31d6cfe0d1","personal-center":"31d6cfe0d1","pintuan":"31d6cfe0d1","order":"31d6cfe0d1","pintuanShare":"31d6cfe0d1","experience-lesson":"31d6cfe0d1","feedBack":"31d6cfe0d1","detail":"31d6cfe0d1","distdetail":"31d6cfe0d1","feed-back-details":"31d6cfe0d1","hof":"31d6cfe0d1","teacher":"31d6cfe0d1","trace":"31d6cfe0d1","imageUpload":"31d6cfe0d1","liveroom":"31d6cfe0d1","upload":"31d6cfe0d1","nimsdk":"31d6cfe0d1"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static-cdn.xiaozhibo.com/vee/xms/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
